import { render, staticRenderFns } from "./Munhandled.vue?vue&type=template&id=1cd30b4f&scoped=true&"
import script from "./Munhandled.vue?vue&type=script&lang=js&"
export * from "./Munhandled.vue?vue&type=script&lang=js&"
import style0 from "./Munhandled.vue?vue&type=style&index=0&id=1cd30b4f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd30b4f",
  null
  
)

export default component.exports